import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

const Tab = ({ tab, selected }) => {
	const cls = classnames(
		'inline-block h-9 px-4 leading-9 bg-white rounded-lg cursor-pointer transition-all',
		selected !== tab.name && 'text-neutral-800 dark:bg-neutral-800 dark:text-white focus:bg-neutral-100 hover:bg-neutral-100 hover:text-neutral-800 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700',
		selected === tab.name && 'bg-amber-500 text-white hover:text-white'
	);

	return (
		<Link className={cls} to={tab.url}>
			{tab.text}
		</Link>
	);
};

export default Tab;